/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdtPositionDto } from '../../models/sdt-position-dto';

export interface CreateSdtPosition$Params {
      body: SdtPositionDto
}

export function createSdtPosition(http: HttpClient, rootUrl: string, params: CreateSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<SdtPositionDto>> {
  const rb = new RequestBuilder(rootUrl, createSdtPosition.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SdtPositionDto>;
    })
  );
}

createSdtPosition.PATH = '/v1/sdtpositions';
